import type { ApiClient } from "./client.ts";
import type {
	TempMediaPresignedUrlQuery,
	TempMediaPresignedUrlQueryVariables,
} from "./temp-media-presigned-url-query.api.generated.ts";
import tempMediaPresignedUrlQuery from "./temp-media-presigned-url-query.api.graphql";

type FileOptions = {
	readonly fileName: string;
	readonly contentType: string;
	readonly content: Uint8Array<ArrayBuffer>;
};

type Options = {
	readonly signal: AbortSignal;
};

async function uploadTempFile(
	apiClient: ApiClient,
	{ fileName, contentType, content }: FileOptions,
	{ signal }: Options,
) {
	const { tempMediaPresignedUrl } = await apiClient.query<
		TempMediaPresignedUrlQuery,
		TempMediaPresignedUrlQueryVariables
	>(tempMediaPresignedUrlQuery, { fileName, contentType }, { signal });
	await fetch(tempMediaPresignedUrl.url, {
		method: "PUT",
		headers: {
			"Content-Type": contentType,
		},
		body: content,
		signal,
	});
	return tempMediaPresignedUrl.key;
}

export default uploadTempFile;
